import {
  FilteredCreditApplication,
  PrequalifyDto
} from '@applyonline/shared/types'

import { apiClient, keysFactory } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { MutationFunction, useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosRequestConfig } from 'axios'
import { Prequalification } from '../types/Schemas/PrequalificationSchema'
import { transformPrequalToApi } from './credit-transform'

export interface SubmitDraftCreditApplicationDto {
  recaptchaToken: string
  prequalification: Prequalification
}

const prequalify: MutationFunction<FilteredCreditApplication, PrequalifyDto> = async ({
  creditApplicationId,
  vouchedJobToken,
  applicantType,
}: PrequalifyDto) => {
  const response = await apiClient.post(`b2c/creditApplication/${creditApplicationId}/prequalify`, {
    vouchedJobToken,
    applicantType,
  })

  return response.data as FilteredCreditApplication
}

export function usePrequalify(): [MutationFunction<FilteredCreditApplication, PrequalifyDto>, boolean, () => void] {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: prequalify,
    onSuccess: (data) => {
      queryClient.setQueryData(keysFactory.detail(data.id, EFinancingProgram.B2c), data)
      return data
    },
  })

  return [mutateAsync, isPending, reset]
}


const submitDraftCreditApplication: MutationFunction<
  FilteredCreditApplication,
  SubmitDraftCreditApplicationDto
> = async (dto: SubmitDraftCreditApplicationDto) => {
  const options: AxiosRequestConfig = {
    headers: {
      'x-recaptcha-token': dto.recaptchaToken,
    },
  }
  const prequal = transformPrequalToApi(dto.prequalification)
  const response = await apiClient.post(`b2c/creditapplication`, prequal, options)
  return response.data as FilteredCreditApplication
}
export function useSubmitDraftCreditApplication(): [
  MutationFunction<FilteredCreditApplication, SubmitDraftCreditApplicationDto>,
  boolean,
  boolean,
  () => void,
] {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending, reset, isSuccess } = useMutation({
    mutationFn: submitDraftCreditApplication,
    onSuccess: (data) => {
      queryClient.setQueryData(keysFactory.detail(data.id, EFinancingProgram.B2c), data)
      return data
    },
  })

  return [mutateAsync, isPending, isSuccess, reset]
}
